import { render, staticRenderFns } from "./ProgramExperts.vue?vue&type=template&id=5bb42212"
import script from "./ProgramExperts.vue?vue&type=script&lang=js"
export * from "./ProgramExperts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports